import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash"
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPhotoShop } from '../../../../../../jsx/actions/shopAction';
import { createResaDemand, validatePrepa, deletePrepa, deleteResa } from '../../../../../../jsx/actions/saleAction';
import { createClient } from '../../../../../../jsx/actions/clientAction';
import Spin from '../../../commonModules/interface/Spin';
import { CardLayout, BreadCrumb } from './containers/Layout';
import ListResaItem from './resas/ListResaItem.jsx';
import ListResa from './resas/ListResa.jsx';
import Form from './resas/Form.jsx';
import SingleResa from './resas/SingleResa.jsx';
import SingleShop from './shops/SingleShop';
import { Button, Card, Grid, Box, IconButton } from '@material-ui/core';
import { ListRounded, ListAltRounded } from '@material-ui/icons';
import CardPage from '../../../commonModules/layouts/CardPage';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import FormResaToSale from './resas/FormResaToSale';
import AccordionFilter from './Filter/AccordionFilter';

class Reservations extends Component{
    state = {
        view: this.props.new ? "new" : "list",
        listview: "sale",

        singleShop:{},
        singleResa:{
            sale:{},
            shop:{},
            client:{},
        },

        breadcrumb: "",
        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,

        selectShop:"",
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchProduct: "", 
    }
        
    componentDidMount = () => {
        if(isEmpty(this.props.AGENTS)){
            this.props.fetchAgents()
        }
        this.props.fetchResas()
    }
    // select options 
        createShopList = () => {
            const list = [{value:"", label:"Tous les Magasins"}]
            const { SHOPS } = this.props
            if( !isEmpty(SHOPS) ){
                Object.values(SHOPS).forEach( shop => { 
                    list.push (       
                        {value:shop.id, label:shop.name} 
                    )
                })
            } 
            return list
        }
        createClientList = () => {
            const list = [{value:"", label:"Tous les Clients"}]
            const { CLIENTS } = this.props
            if( CLIENTS ){
                Object.values(CLIENTS).map(client => { 
                    list.push (       
                        {value:client.id, label:client.client_lastname} 
                    )
                })
            } 
            return list
        }
        normalizeStr = (str) => {// remove accent and lower case str
            if (str){
                console.log("str exist", {str}, isEmpty(str));
                str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
            return str
        }
        prodFilter = (prodID) => {
            const { PRODUCTS } = this.props;
            const { searchProduct } = this.state
    
            let product = PRODUCTS[prodID]
            let searching = searchProduct ? this.normalizeStr(searchProduct) : ""
    
            const productName = product ? this.normalizeStr(product.name) : ""
            const productRef = product ? this.normalizeStr(product.ref) : ""
            const productType = product ? this.normalizeStr(product.type) : ""
            const productBrand = product ? this.normalizeStr(product.marque) : ""
    
            return ( 
                productName.indexOf(searching) !== -1 ||
                productRef.indexOf(searching) !== -1 ||
                productType.indexOf(searching) !== -1 ||
                productBrand.indexOf(searching) !== -1
            )  
        }

        handleChange = (e) => {
            const { name, value } = e.target;
            this.setState({
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            })
        }
        handleSelect = (option, name) => {
            this.setState({
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            })
        } 

        getFilteredList = () => {
            const { RESAS } = this.props;
            const { selectShop, searchClient, searchFacture, searchType } = this.state;
            
            let list = Object.values(RESAS)
            // status
            var received
            if (typeof received == "boolean"){
                list = list.filter(item => item.received == received)
            }
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
                // list = list.filter(item => this.filterClients(item))
            }
            // shop
            if(!isEmpty(selectShop)){
                list = list.filter(item => item.shop_id === selectShop)
            }
            // fact
            if(!isEmpty(searchFacture)){
                list = list.filter(item => item.id && item.id.indexOf(searchFacture.toLocaleLowerCase()) > -1)
            }
          
            return list
        }
    // CLEAR & DISPLAY
        handleClose = () => {
            this.setState({
                view:"list",
                breadcrumb: "",
                singleResa:{
                    sale:{},
                    shop:{},
                    client:{},
                },
            });
            // this.clearForms()
        }
        handleSingleResa = (sale, shop, client) => {
            this.setState({
                view:"sale",
                breadcrumb:`Reservation n°${sale.id}`,
                singleResa:{sale, shop, client},
            })
        }
        handleResaToSale = (sale, client) => {
            this.setState({
                view:"newSale",
                breadcrumb:`Reservation n°${sale.id}`,
                singleResa:{sale, client},
            })
        }
        handleSingleShop = (shop) => {
            this.setState({
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            })
        }
        onChangePage = (pageOfItems, page, rowsPerPage) => {
            this.setState({ currentPage:page, rowsPerPage });
        }
        onChangePageProd = (pageOfItemsProd, page , rowsPerPage) => {
            this.setState({ currentPageProd:page , rowsPerPage});
        }
    render(){
        console.log("[STATE] stock ",this.state);
        let shops = this.createShopList()
        let clients = this.createClientList()

        return(
            <CardPage title="Réservations" storehouse action={
                <Box>
                    {this.state.view === "list" &&
                    <Fragment>
                        <Button color="primary" variant="contained"
                            onClick={ ()=> this.setState({view: "new", breadcrumb:"Nouveau"}) }
                        > Nouvelle Réservation </Button>
                        {this.state.listview === "sale" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Produits"
                                onClick={()=> this.setState({ view: "list", listview: "prodList" }) }
                            >
                                <ListRounded />
                            </IconButton>
                        }
                        {this.state.listview === "prodList" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Réservations"
                                onClick={()=> this.setState({ view: "list", listview: "sale" }) }
                            >
                                <ListAltRounded />
                            </IconButton>
                        }

                    </Fragment>
                    }
                </Box>
            }>
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Réservations" back={this.handleClose} />
                {this.state.view === "new" &&
                    <Form {...this.props} handleClose={ this.handleClose } />
                }
                {this.state.view === "newSale" &&
                    <FormResaToSale
                        {...this.props} 
                        resa={this.state.singleResa.sale} 
                        client={this.state.singleResa.client} 
                        handleClose={ this.handleClose }
                    />
                }
                {this.state.view === "sale" &&
                    <SingleResa 
                        resa={this.state.singleResa.sale} 
                        shop={this.state.singleResa.shop} 
                        client={this.state.singleResa.client} 
                        {...this.props} 
                        getPhoto={this.props.getPhoto} 
                    />
                }
                {this.state.view === "shop" &&
                    <SingleShop shop={this.state.singleShop} {...this.props} />
                }
                  
                {this.state.view === "list" &&
                // {this.state.view === "list" && (this.state.listview === "sale" ||  this.state.listview === "prodList") &&
                <AccordionFilter>
                    <Grid container >
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={shops}
                                value={this.state.selectShop}
                                label="Sélectionner un Magasin"
                                onChange={(option) => this.handleSelect(option, "selectShop") }
                            /> 
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={clients}
                                value={this.state.searchClient}
                                label="Client"
                                onChange={(option) => this.handleSelect(option, "searchClient") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputText
                                label="Facture"
                                value={this.state.searchFacture}
                                name="searchFacture"
                                onChange={this.handleChange}
                            /> 
                        </Grid>
                        {this.state.listview === "prodList" &&
                        <Grid item xs={12} md={6}>
                            <InputText 
                                name="searchProduct" 
                                value={this.state.searchProduct} 
                                placeholder="Rechercher par produit " 
                                label="Rechercher"
                                onChange={ this.handleChange} 
                            />
                        </Grid>
                        }
                    </Grid>
                </AccordionFilter>
                }
                {this.props.STATE.resas.fetching && <Spin noOverlay />}
               
                {this.state.view === "list" && this.state.listview === "sale" &&
                <Box>                    
                    {!isEmpty(this.props.RESAS) &&
                        <ListResa 
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePage}
                            handleResaToSale={this.handleResaToSale}  
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleResa={this.handleSingleResa}  
                            getFilteredList={this.getFilteredList}  
                            prodFilter={this.prodFilter}  
                        />
                    }
                </Box>
                }
                {this.state.view === "list" && this.state.listview === "prodList" &&
                <Box> 
                    {!isEmpty(this.props.RESAS) &&
                        <ListResaItem
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePageProd}
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleResa={this.handleSingleResa}  
                            getFilteredList={this.getFilteredList}  
                            prodFilter={this.prodFilter}  
                        />
                    }
                </Box>
                }
            </CardPage>
        )
    }
}


// function mapStateToProps(state){// transform elements from store's state into props in this component
//     return {
//         state: state.inventory.requestState.resas,
//         stateClient: state.inventory.requestState.clients,
//     }
// }

export default Reservations